import React from 'react';
import { useTranslatedContent } from '../../i18n/hooks/useTranslatedContent';
import VirtualizationSolution from './solutions/VirtualizationSolution';
import EmailSolution from './solutions/EmailSolution';
import NetworkSolution from './solutions/NetworkSolution';
import RemoteAccessSolution from './solutions/RemoteAccessSolution';
import InfrastructureFeatures from './features/InfrastructureFeatures';

const InfrastructureSection = () => {
  const { t } = useTranslatedContent('infrastructure');

  return (
    <div id="infrastructure" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Hero Section */}
        <div className="relative mb-20">
          {/* Background Pattern */}
          <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-indigo-500/10 rounded-3xl" />
          
          <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-12 items-center p-8 lg:p-12">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl mb-6">
                {t('title')}
              </h2>
              <p className="text-xl text-gray-600 mb-8">
                {t('subtitle')}
              </p>
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-white/80 backdrop-blur-sm rounded-xl p-4 shadow-sm">
                  <div className="text-3xl font-bold text-blue-600 mb-1">{t('stats.uptime.value')}</div>
                  <div className="text-sm text-gray-600">{t('stats.uptime.label')}</div>
                </div>
                <div className="bg-white/80 backdrop-blur-sm rounded-xl p-4 shadow-sm">
                  <div className="text-3xl font-bold text-blue-600 mb-1">{t('stats.support.value')}</div>
                  <div className="text-sm text-gray-600">{t('stats.support.label')}</div>
                </div>
              </div>
            </div>
            
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 to-indigo-500/20 rounded-2xl transform rotate-3"></div>
              <img
                src="https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80"
                alt="Modern Data Center Infrastructure"
                className="relative rounded-2xl shadow-xl transform -rotate-3 hover:rotate-0 transition-transform duration-500"
              />
            </div>
          </div>
        </div>

        <div className="space-y-20">
          <VirtualizationSolution />
          <EmailSolution />
          <NetworkSolution />
          <div id="remote">
            <RemoteAccessSolution />
          </div>
          <InfrastructureFeatures />
        </div>
      </div>
    </div>
  );
};

export default InfrastructureSection;